/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(function () {
  Object.keys(window.DeskCollectionBar || {}).forEach(function (sectionId) {
    var $bar = $('#collection-bar-' + sectionId);
    if (!$bar.length) return;

    if ($bar.parent().is('body') === false) {
      $bar.appendTo('body');
    }

    var $headerContainer = $('.desk_header-container');
    var $headerInner = $('.desk_header-inner-container');
    var $announcement = $('.desk_header-announcment');

    var pastIntro = false;
    var headerHidden = $headerInner.length ? $headerInner.hasClass('headerDown') : false;

    var navLockActive = false;
    var lockedHeaderHidden = null;

    function getHeaderHeight() {
      if (headerHidden) return 0;
      var totalHeight = 0;
      if ($announcement.length) totalHeight += $announcement.outerHeight();
      if ($headerContainer.length) totalHeight += $headerContainer.outerHeight();
      return totalHeight;
    }

    function updateTopOffset() {
      if (headerHidden) {
        $bar.css('top', '0px');
        return;
      }
      $bar.css('top', getHeaderHeight() + 'px');
    }

    updateTopOffset();

    if ($headerInner.length && !$headerInner.data('deskCollectionBarForcedTransition')) {
      $headerInner.data('deskCollectionBarForcedTransition', true);
      $headerInner.css('transition', 'transform 0.3s ease');
    }

    function updateHeaderInnerTransform() {
      if (!$headerInner.length) return;
      $headerInner.css('transform', headerHidden ? 'translateY(-100%)' : 'translateY(0)');
    }

    function updateBarZIndex() {
      $bar.css('z-index', headerHidden ? 9998 : 9997);
    }

    updateHeaderInnerTransform();
    updateBarZIndex();

    if ($headerInner.length && 'ResizeObserver' in window) {
      new ResizeObserver(updateTopOffset).observe($headerInner[0]);
    } else {
      $(window).on('resize', updateTopOffset);
    }

    var $sentinel = $('#collection-bar-sentinel-' + sectionId);
    var $items = $bar.find('.collection-bar__item');
    var $underline = $bar.find('.collection-bar__underline');

    function updateVisibility() {
      $bar.toggleClass('is-visible', pastIntro);
    }

    if ($sentinel.length && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          pastIntro = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateVisibility();
        });
      }, { threshold: 0 }).observe($sentinel[0]);
    }

    if ($headerInner.length && 'MutationObserver' in window) {
      new MutationObserver(function () {
        var isDown = $headerInner.hasClass('headerDown');

        if (navLockActive) {
          if (isDown !== lockedHeaderHidden) {
            if (lockedHeaderHidden) {
              $headerInner.addClass('headerDown');
            } else {
              $headerInner.removeClass('headerDown');
            }
          }
          return;
        }

        if (isDown !== headerHidden) {
          headerHidden = isDown;
          updateTopOffset();
          updateHeaderInnerTransform();
          updateBarZIndex();
          updateVisibility();
        }
      }).observe($headerInner[0], { attributes: true, attributeFilter: ['class'] });
    }

    var anchors = [];
    $items.each(function () {
      var $item = $(this);
      var href = $item.attr('href') || '';
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      var id = href.slice(hashIndex + 1);
      if (!id) return;
      var $section = $(document.getElementById(id));
      if ($section.length) {
        anchors.push({ $item: $item, $section: $section });
      }
    });

    if (!anchors.length) return;

    anchors.sort(function (a, b) {
      return a.$section.offset().top - b.$section.offset().top;
    });

    var currentActiveItem = null;
    var isScrollingToTarget = false;

    function getThreshold() {
      return window.innerHeight * 0.4;
    }

    var $nav = $bar.find('.collection-bar__nav');

    function moveUnderline($item) {
      if (!$item || !$item.length) return;
      var itemPos = $item.position();
      $underline.css({
        left: itemPos.left,
        width: $item.outerWidth()
      });
    }

    function centerActiveItem($item) {
      if (!$item || !$item.length || !$nav.length) return;
      if ($(window).width() > 1279) return;

      var containerWidth = $nav.outerWidth();
      var itemWidth = $item.outerWidth();
      var itemOffsetLeft = $item.position().left;
      var scrollPosition = $nav.scrollLeft() + itemOffsetLeft - containerWidth / 2 + itemWidth / 2;

      $nav.stop(true).animate({ scrollLeft: scrollPosition }, 300);
    }

    function setActive($item) {
      if (currentActiveItem && currentActiveItem[0] === $item[0]) return;
      $items.removeClass('is-active');
      $item.addClass('is-active');
      currentActiveItem = $item;
      moveUnderline($item);
      centerActiveItem($item);
    }

    function clearActive() {
      if (!currentActiveItem) return;
      $items.removeClass('is-active');
      currentActiveItem = null;
    }

    function update() {
      if (isScrollingToTarget) return;

      var threshold = getThreshold();
      var lastBottom = anchors[anchors.length - 1].$section[0].getBoundingClientRect().bottom;

      if (lastBottom < 0) {
        clearActive();
        return;
      }

      var active = null;
      $.each(anchors, function (i, item) {
        if (item.$section[0].getBoundingClientRect().top <= threshold) active = item;
      });

      if (active) {
        setActive(active.$item);
      } else {
        clearActive();
      }
    }

    function getScrollOffset(match) {
      var offset = getHeaderHeight() + ($bar.outerHeight() || 0) + 20;

      if (match) {
        var $extraSticky = match.$section.find('.desk_product-comparison__sticky');
        if ($extraSticky.length) {
          offset += $extraSticky.outerHeight() || 0;
        }
      }

      return offset;
    }

    var scrollEndHandler = null;
    var settleFrame = null;

    function stopWatchingScroll() {
      if (settleFrame) {
        cancelAnimationFrame(settleFrame);
        settleFrame = null;
      }
      if (scrollEndHandler) {
        window.removeEventListener('scrollend', scrollEndHandler);
        scrollEndHandler = null;
      }
    }

    function releaseNavLock() {
      navLockActive = false;
      isScrollingToTarget = false;
      update();
    }

    function scrollToAnchor(match) {
      stopWatchingScroll();

      var current = window.pageYOffset || document.documentElement.scrollTop;
      var targetTop = match.$section.offset().top;
      var scrollingUp = targetTop < current;

      var predictedHidden = scrollingUp ? false : headerHidden;

      navLockActive = true;
      lockedHeaderHidden = predictedHidden;

      if (predictedHidden) {
        $headerInner.addClass('headerDown');
      } else {
        $headerInner.removeClass('headerDown');
      }

      headerHidden = predictedHidden;
      updateTopOffset();
      updateHeaderInnerTransform();
      updateBarZIndex();

      var offset = getScrollOffset(match);
      match.$section.css('scroll-margin-top', offset + 'px');

      isScrollingToTarget = true;

      match.$section[0].scrollIntoView({ behavior: 'smooth', block: 'start' });

      if ('onscrollend' in window) {
        scrollEndHandler = function () {
          window.removeEventListener('scrollend', scrollEndHandler);
          scrollEndHandler = null;
          releaseNavLock();
        };
        window.addEventListener('scrollend', scrollEndHandler);
      } else {
        var lastPos = window.pageYOffset;
        var stableFrames = 0;

        var check = function () {
          var pos = window.pageYOffset;
          if (Math.abs(pos - lastPos) < 1) {
            stableFrames++;
          } else {
            stableFrames = 0;
          }
          lastPos = pos;

          if (stableFrames > 5) {
            settleFrame = null;
            releaseNavLock();
            return;
          }
          settleFrame = requestAnimationFrame(check);
        };

        settleFrame = requestAnimationFrame(check);
      }
    }

    $items.on('click', function (e) {
      var $clicked = $(this);
      var match = null;
      $.each(anchors, function (i, item) {
        if (item.$item[0] === $clicked[0]) { match = item; return false; }
      });
      if (!match) return;

      e.preventDefault();
      scrollToAnchor(match);
    });

    $(window).on('scroll.collectionBarActive', update);
    update();

    $(window).on('resize', function () {
      moveUnderline(currentActiveItem);
      centerActiveItem(currentActiveItem);
    });

    window.dispatchEvent(new Event('scroll'));
  });
});